import React, {useState} from 'react'
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from '../../common/Pagination/Pagination';
import find from "lodash/find";
import { Button } from '../../common/Button/Button';

const ReactTableFixedColumns = withFixedColumns(ReactTable);


const ClosedServiceReactTable = (props) => {

    const columns = [
        {
            id: 'nResourceInstanceId',
            Header: 'Service Name + Service Id',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            // accessor: "nResourceInstanceId",
            // width: 200,
            Cell: ({ original }) => (
				<>
					<div className={"conv-float-left"}>
                                        <div style={{"clear":"both"}}></div>
										<div  className="conv-mt10">
											{
												original.sServiceDisplayName?
												(
													<>
														<span className="lpm-service-grid-value conv-mr13" style={{wordBreak:"break-word"}}>
															
															{
																original.sServiceDisplayName
															}
														</span><br></br>
													</>
												)
												:
												("NA")
											}
										</div>
										<div style={{"clear":"both"}}></div>
										<div className="conv-mt10">
										<span className="conv-float-left conv-mr5 lpm-service-grid-key">ID: {original.nResourceInstanceId? original.nResourceInstanceId : "NA"}</span>
										</div>
									</div>
				</>
			),
        },
        {
            id: 'nPackageInstanceId',
            Header: 'Parent Id',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            // accessor: "nResourceInstanceId",
            // width: 200,
            Cell: ({ original }) => (
				<>
					<div className={"conv-float-left"}>
                                        <div style={{"clear":"both"}}></div>
										{/* <div  className="conv-mt10">
											{
												original.sPackageDisplayName?
												(
													<>
														<span className="lpm-service-grid-value conv-mr13" style={{wordBreak:"break-word"}}>
															
															{
																original.sPackageDisplayName
															}
														</span><br></br>
													</>
												)
												:
												("NA")
											}
										</div> */}
										<div style={{"clear":"both"}}></div>
										<div className="conv-mt10">
										<span className="conv-float-left conv-mr5 lpm-service-grid-key">Parent ID:  {original.nParentId? original.nParentId : 'NA'}</span>
										</div>
									</div>
				</>
			),
        },
        {
            id: 'sEmailAddress',
            Header: 'Customer Details',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            // accessor: "sEmailAddress",
            width:310,
            Cell: ({ original }) => (
				<>
					<div className={"conv-float-left"}>
                    
										<div>
										<span className="conv-float-left conv-mr5 lpm-service-grid-key">Name:</span>
											{
												original.sFirstName && original.sLastName ?
												(
													<>
														<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
                                                        {
                                                            `${original.sFirstName &&
                                                                original.sFirstName 
                                                            }${' '}
                                                            ${original.sLastName &&
                                                                original.sLastName 
                                                            }`
                                                        }
														</span>
													</>
												)
												:
												<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
															{("NA")}
														</span>
											}
										</div>
                                        <div style={{"clear":"both"}}></div>
										<div  className="conv-mt10">
											<span className="conv-float-left conv-mr18 lpm-service-grid-key">Email:</span>
											{
												original.sEmailAddress?
												(
													<>
														<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all"}}>
															
															{
																original.sEmailAddress
															}
														</span><br></br>
													</>
												)
												:
												("NA")
											}
										</div>
										<div style={{"clear":"both"}}></div>
										<div className="conv-mt10">
										<span className="conv-float-left conv-mr5 lpm-service-grid-key">Contact:</span>
											{
												original.sContactNumber?
												(
													<>
														<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
															{
																original.sContactNumber
															}
														</span>
													</>
												)
												:
												<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
															{("NA")}
														</span>
											}
										</div>
									</div>
				</>
			),
        },
        {
            id: 'sServiceIn',
            Header: 'Module',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "sServiceIn",
            width:130,
        },
        {
            id: 'IsPackage',
            Header: 'Is Package',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "IsPackage",
            width:130,
            Cell: ({ value }) => (value ? 'Yes' : 'No')
        },
        {
            Header: 'Action',
            id: 'action',
            Cell: ({ original }) => (
                <Button className="esp-inline-button"
                 onClick={() => props.onOpenBtnClick(original.nParentId)}
                 >ReOpen</Button>
            ),
            width: 200
        }
    ]

      

  return (
    <div className="col-12 conv-mt25 conv-pl40 conv-pr40 spled-container fix-filter">

        <div className="spled-container">
            <div className="service-partner spled-container">
            <ReactTableFixedColumns
						minRows={0}
						data={props.data || []}
						columns={columns}
						manual
						defaultPage={props.page}
						pages={props.pages}
						page={props.page}
						pageSize={props.pageSize}
						sortable={false}
						defaultPageSize={10}
						showPagination={true}
						pageSizeOptions={[10,20,30,50,75,100]}
						onFetchData={(state, instance) => {
							props.onFetchServiceRequests(instance, false);
						}}
						onPageSizeChange={props.onPageSizeOptionChange}
						PaginationComponent={Pagination}
						style={{overflowY: "initial",height: "390px"}}			
						className="-striped hide-scrollbar"
					/>
            </div>
        </div>
      
    </div>
  )
}

export default ClosedServiceReactTable
